import { render } from "./TemplateBookBookingResultProcessing.vue?vue&type=template&id=d50d3552&scoped=true"
import script from "./TemplateBookBookingResultProcessing.vue?vue&type=script&lang=js"
export * from "./TemplateBookBookingResultProcessing.vue?vue&type=script&lang=js"

import "./TemplateBookBookingResultProcessing.vue?vue&type=style&index=0&id=d50d3552&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d50d3552"

export default script